const setupNominationsModal = (root) => {
  const trigger = root.querySelector('[data-nominations-modal-open]');
  const overlay = root.querySelector('.nominations-modal__overlay');
  const closeButtons = root.querySelectorAll('[data-nominations-modal-close]');

  if (!trigger || !overlay) {
    return;
  }

  const openModal = () => {
    document.body.append(overlay);
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nominations-modal-open');
  };

  const closeModal = () => {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nominations-modal-open');
    root.append(overlay);
    trigger.focus();
  };

  trigger.addEventListener('click', openModal);
  closeButtons.forEach((button) => button.addEventListener('click', closeModal));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      closeModal();
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-nominations-modal]').forEach(setupNominationsModal);
});